module.exports = __webpack_public_path__ + "img/4-min.fec66c44.jpg";